export const decline = (word: [string, string, string], number: number) => {
  const [one, two, five] = word;

  let absNumber = Math.abs(number);

  // https://gist.github.com/termi/7081408#file-declension-js-L18
  // prettier-ignore
  return absNumber <= 14 && absNumber >= 11
      ? five
      : (absNumber %= 10) < 5
        ? absNumber >= 2
          ? two
          : absNumber === 1
            ? one
            : absNumber === 0
              ? five
              : one
        : five;
};
